import { Text, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { HFieldProps } from './HField.type';

/**
 * HField component.
 *
 * @component
 * @param {HFieldProps} props - The props for the HField component.
 * @param {string} props.name - The name to be displayed in the HField component.
 * @param {string} props.value - The value to be displayed in the HField component.
 * @returns {ReactElement} The rendered HField component.
 */
export const HField = ({ name, value }: HFieldProps): ReactElement => {
  return (
    <VStack align='start' spacing={1}>
      <Text fontWeight='bold' color='grey.100'>
        {name}
      </Text>
      <Text fontSize='s' color='grey.800'>
        {value}
      </Text>
    </VStack>
  );
};
